import createIcon from '../../createIcon';

/**
 * @component @name Shortcut
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTFMMTUgNVYxMEg4QzUuMjQgMTAgMyAxMi4yNCAzIDE1VjE5SDVWMTVDNSAxMy4zNSA2LjM1IDEyIDggMTJIMTVWMTdMMjEgMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Shortcut = createIcon('Shortcut', [
  [
    'path',
    {
      d: 'M21 11L15 5V10H8C5.24 10 3 12.24 3 15V19H5V15C5 13.35 6.35 12 8 12H15V17L21 11Z',
      key: 'nmuow2',
    },
  ],
]);

export default Shortcut;
